import { createContext, useState } from "react";

export const RootContext = createContext();

function RootContextProvider({ children, isRouteLoading, setIsRouteLoading }) {
  const [isNavMenuOpen, setIsNavMenuOpen] = useState(false);
  const [navHeight, setNavHeight] = useState(0);

  return (
    <RootContext.Provider
      value={{
        isNavMenuOpen,
        setIsNavMenuOpen,
        navHeight,
        setNavHeight,
        isRouteLoading,
        setIsRouteLoading
      }}
    >
      {children}
    </RootContext.Provider>
  );
}

export default RootContextProvider;
